import React, { useState, useEffect } from "react";
import { registerHr } from "../../api/api";
import "./authcustom.css";
import { Link } from "react-router-dom";

function HrRegister() {
  const [form, setForm] = useState({ name: "", mobile: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(""); // 'success' or 'error'
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setShowPopup(false);
    try {
      await registerHr(form);
      setSuccess("Registration successful! Wait for admin approval.");
      setPopupType("success");
      setShowPopup(true);
      setForm({ name: "", mobile: "", email: "", password: "" });
    } catch (err) {
      setError(
        err.response?.data?.error || "Registration failed. Mobile or Email may already be registered."
      );
      setPopupType("error");
      setShowPopup(true);
    }
  };

  // Auto-hide popup after 3 seconds
  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => setShowPopup(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '60px' }}>
      <div className="auth-form-container">
      <h2>HR Registration</h2>
      <form onSubmit={handleSubmit}>
        <label className="auth-label">Name
          <input name="name" type="text" placeholder="Enter your name" value={form.name} onChange={handleChange} required className="auth-input" />
        </label>
        <label className="auth-label">Mobile
          <input name="mobile" type="tel" placeholder="Enter your mobile" value={form.mobile} onChange={handleChange} required className="auth-input" />
        </label>
        <label className="auth-label">Email
          <input name="email" type="email" placeholder="Enter your email" value={form.email} onChange={handleChange} required className="auth-input" />
        </label>
        <label className="auth-label">Password
          <div style={{ position: "relative" }}>
            <input name="password" type={showPassword ? "text" : "password"} placeholder="Create a password" value={form.password} onChange={handleChange} required className="auth-input" autoComplete="new-password" />
            <button type="button" className="auth-show-btn" onClick={() => setShowPassword(s => !s)} tabIndex={-1} aria-label={showPassword ? "Hide password" : "Show password"}>
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
        </label>
        <button type="submit">Register</button>
      </form>
      <div className="auth-link-container">
        <span>Already registered?</span>
        <Link to="/hr-login" className="auth-link">Login as HR</Link>
      </div>
      {error && <div style={{ color: "red" }}>{error}</div>}
      {success && <div style={{ color: "green" }}>{success}</div>}

      {/* Side Popup Message */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 30,
            right: 30,
            minWidth: 250,
            zIndex: 9999,
            background: popupType === "success" ? "#4BB543" : "#e74c3c",
            color: "#fff",
            padding: "16px 28px",
            borderRadius: 8,
            boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
            fontSize: 16,
            fontWeight: 500,
            letterSpacing: 0.2,
            transition: "all 0.3s"
          }}
        >
          {popupType === "success" ? success : error}
        </div>
      )}
      </div>
    </div>
  );
}

export default HrRegister;
